import { add } from '@aeris/money';
import { ZERO_AMOUNT, daysOverdue, outstanding, } from "./entities.js";
/**
 * Ageing — the one report a shopkeeper actually reads.
 *
 * "Quanto eu tenho a receber?" is the wrong question and everybody asks the
 * right one instead: *how old is it?* R$ 40.000,00 due next week and
 * R$ 40.000,00 ninety days late are the same total and completely different
 * businesses. The buckets below are the ones every Brazilian ERP prints,
 * because they are the ones a collections conversation is organised around.
 */
export const AGEING_BUCKETS = [
    /** Not due yet. The healthy pile. */
    'current',
    '1-30',
    '31-60',
    '61-90',
    /** Past ninety days. In practice, what gets written off or sold. */
    'over-90',
];
export const AGEING_BUCKET_LABELS = {
    current: 'A vencer',
    '1-30': '1 a 30 dias',
    '31-60': '31 a 60 dias',
    '61-90': '61 a 90 dias',
    'over-90': 'Mais de 90 dias',
};
export const bucketFor = (entry, now) => {
    const days = daysOverdue(entry, now);
    if (days <= 0)
        return 'current';
    if (days <= 30)
        return '1-30';
    if (days <= 60)
        return '31-60';
    if (days <= 90)
        return '61-90';
    return 'over-90';
};
/**
 * Sums what is still outstanding, by age.
 *
 * Outstanding rather than face value: a R$ 1.000,00 title with R$ 900,00 paid
 * is R$ 100,00 of exposure, and a report that showed the thousand would have
 * the shop chasing money it already has.
 *
 * Cancelled and settled titles are excluded — one is not owed and the other is
 * not owed any more. Every bucket is returned even when empty, so the screen
 * shows a column of zeroes rather than a table that changes shape.
 */
export const ageing = (entries, now) => {
    const totals = new Map(AGEING_BUCKETS.map((bucket) => [bucket, { amount: ZERO_AMOUNT, count: 0 }]));
    for (const entry of entries) {
        if (entry.status !== 'open')
            continue;
        const rest = outstanding(entry);
        const bucket = bucketFor(entry, now);
        const running = totals.get(bucket);
        if (running === undefined)
            continue;
        totals.set(bucket, {
            amount: add(running.amount, rest),
            count: running.count + 1,
        });
    }
    return AGEING_BUCKETS.map((bucket) => {
        const running = totals.get(bucket) ?? { amount: ZERO_AMOUNT, count: 0 };
        return { bucket, amount: running.amount, count: running.count };
    });
};
//# sourceMappingURL=ageing.js.map